<h2 nxHeadline="section" align="center">
  {{ "homeFinalDetails.title" | translate }}
</h2>
<form [formGroup]="parentForm" class="formClass">
  <qbe-panel-component>
    <div nxRow class="inner-element outer-element">
      <div nxCol="12, 12, 7" class="inner-element-left">
        <div class="inner-element-left-title">
          {{ "details4.insurancestart" | translate }}
        </div>
      </div>
      <div nxCol="12, 12, 5" class="inner-element-right align-center" style="padding-right: 30px !important;">
        <nx-formfield label="{{ 'details4.startdate' | translate }}">
          <input
            nxDatefield
            [parseFormat]="parseFormat"
            displayFormat="DD.MM.YYYY"
            nxInput
            [datepicker]="insuranceStart"
            [min]="minDate"
            [max]="maxDate"
            formControlName="insuranceStart"
            (dateChange)="
              chosenDateHandler(this.parentForm.controls.insuranceStart.value)
            "
          />
          <nx-datepicker-toggle
            [for]="insuranceStart"
            nxFormfieldSuffix
          ></nx-datepicker-toggle>
          <nx-datepicker
            #insuranceStart
            (change)="this.trackService.checkErrors( parentForm.controls.insuranceStart, 'Insurance start date')" 
          ></nx-datepicker>
          <span nxFormfieldHint>DD.MM.YYYY</span>
        </nx-formfield>
      </div>
    </div>

    <div nxRow class="inner-element">
      <div
        nxCol="12, 12, 7"
        class="inner-element-left"
        [ngClass]="{
          pbottom48: parentForm.controls.isFinancedThroughLoan.value === 'Y'
        }"
      >
        <div class="inner-element-left-title">
          {{ "details4.loanfinanced" | translate }}
        </div>
      </div>
      <div
        nxCol="12, 12, 5"
        class="inner-element-right align-center buttonsContainer"
      >
        <input type="radio" value="Y" formControlName="isFinancedThroughLoan" />
        <qbe-button mode="secondary" class="yesno-button">
          <label>
            {{ "common.yes" | translate }}
            <input
              type="radio"
              value="Y"
              formControlName="isFinancedThroughLoan"
              (click)="
                trackService.addAttribute('propertyDetails.financedLoan', 'Yes')
              "
            />
          </label>
        </qbe-button>
        <input type="radio" value="N" formControlName="isFinancedThroughLoan" />
        <qbe-button mode="secondary" class="yesno-button">
          <label>
            {{ "common.no" | translate }}
            <input
              type="radio"
              value="N"
              formControlName="isFinancedThroughLoan"
              (click)="trackService.addAttribute('propertyDetails.financedLoan', 'No')"
            />
          </label>
        </qbe-button>
      </div>

      <div
        ngCol="12"
        class="inner-element-center bank-panel"
        *ngIf="parentForm.controls.isFinancedThroughLoan.value === 'Y'"
      >
        <div nxRow class="bankDetails">
          <div nxCol="12, 12, 7">
            <div class="inner-element-left-title">
              {{ "details4.banknametitle" | translate }}
            </div>
          </div>
          <div nxCol="12, 12, 5">
            <nx-formfield [label]="'details4.bankname' | translate">
              <nx-dropdown
                formControlName="companyBeneficiaryData"
                [showFilter]="true"
                filterPlaceholder="Type to filter item"
              >
                <nx-dropdown-item
                  *ngFor="
                    let bank of sharedService.bnfBank$ | async | bankTransform
                  "
                  class="bank-select"
                  [value]="bank"
                  (click)="
                    trackService.addAttribute('propertyDetails.bankName', bank.companyName)
                  "
                >
                  {{ bank.companyName }}
                </nx-dropdown-item>
              </nx-dropdown>
            </nx-formfield>
          </div>
        </div>
      </div>
    </div>
    <div nxRow class="inner-element">
      <div nxCol="12, 12, 7" class="inner-element-left">
        <div class="inner-element-left-title">
          {{ "details4.ownerSameAsPolicyHolder" | translate }}
        </div>
      </div>
      <div
        nxCol="12, 12, 5"
        class="inner-element-right align-center buttonsContainer"
      >
        <input type="radio" value="Y" formControlName="samePerson" />
        <qbe-button mode="secondary" class="yesno-button">
          <label>
            {{ "common.yes" | translate }}
            <input
              type="radio"
              value="Y"
              formControlName="samePerson"
              (click)="trackService.addAttribute('userDetails.samePerson', 'Yes')"
            />
          </label>
        </qbe-button>
        <input type="radio" value="N" formControlName="samePerson" />
        <qbe-button mode="secondary" class="yesno-button">
          <label>
            {{ "common.no" | translate }}
            <input
              type="radio"
              value="N"
              formControlName="samePerson"
              (click)="trackService.addAttribute('userDetails.samePerson', 'No')"
            />
          </label>
        </qbe-button>
      </div>
    </div>
    <div nxRow class="inner-element">
      <div nxCol="12, 12, 7" class="inner-element-left">
        <div class="inner-element-left-title">
          {{ "details4.propertyAddressSameAsCorrespondence" | translate }}
        </div>
      </div>
      <div
        nxCol="12, 12, 5"
        class="inner-element-right align-center buttonsContainer"
      >
        <input
          type="radio"
          value="Y"
          formControlName="isPropertyAddressSameAsCorrespondence"
        />
        <qbe-button mode="secondary" class="yesno-button">
          <label>
            {{ "common.yes" | translate }}
            <input
              type="radio"
              value="Y"
              formControlName="isPropertyAddressSameAsCorrespondence"
              (click)="
                trackService.addAttribute(
                  'userDetails.isPropertyAddressSameAsCorrespondence',
                  'Yes'
                )
              "
            />
          </label>
        </qbe-button>
        <input
          type="radio"
          value="N"
          formControlName="isPropertyAddressSameAsCorrespondence"
        />
        <qbe-button mode="secondary" class="yesno-button">
          <label>
            {{ "common.no" | translate }}
            <input
              type="radio"
              value="N"
              formControlName="isPropertyAddressSameAsCorrespondence"
              (click)="
                trackService.addAttribute(
                  'userDetails.isPropertyAddressSameAsCorrespondence',
                  'No'
                )
              "
            />
          </label>
        </qbe-button>
      </div>
    </div>
  </qbe-panel-component>
</form>
